import React from "react";

const ErrorMessage = (props) => {
  return Object.keys(props.analyticsRecords.postbyNetwork).length &&
    ((props.analyticsStatus ||
      !props.analyticsRecords.selected_feed_data.length) && props.analyticsRecords.analytics_status_loader) ? (
      <div className="row">
        <div className="d-flex flex-column-fluid main_content">
          <div className="w-100">
            <div className="alert custom-alert p-2">
              {!props.postCount ? (
                <span>
                  This is sample data as you have not added any feed yet. To see
                  real-time analytics, you'd need to add a feed.
                </span>
              ) : (
                <>
                  <span>
                    {" "}
                    This is sample data as your plan hasn't been upgraded. To
                    access real-time analytics, please upgrade your plan.
                  </span>
                  <a
                    className="free-trial-upgrade cursor-pointer"
                    onClick={() => props.togglePlanSection()}
                  >
                    Upgrade Now
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    ) : null
};

export default React.memo(ErrorMessage);
